// employee-portal/src/RequireEmpAuth.jsx
import { Navigate, useLocation } from "react-router-dom";
import { isLoggedIn } from "./auth";

const RequireEmpAuth = ({ children }) => {
  const location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

export default RequireEmpAuth;
